<template>
  <div>
    <div style="padding-left: 30px; padding-right: 30px;">
      <div class="col-lg-12 col-xl-8">
        <filter-options
          v-bind:pageTitle="pageTitle"
          v-bind:filterItems="filterItems"
          v-on:filter-updated="filterContract"
        />
      </div>

      <div style="margin-top: 8px;">
        <b-table
          responsive
          show-empty
          :empty-text="$t('no_service_objects_were_found')"
          ref="table"
          class="service-objects-table"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="serviceContractsProvider"
          :fields="fields"
          @sort-changed="sortingChanged"
        >
          <template v-slot:table-busy>
            <div style="margin: 0 auto; height: 32px;">
              <div
                class="mb-3"
                style="color: #18385f; position: absolute; left:0; right:0; margin: auto;"
              >
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>

          <template v-slot:empty>
            <div style="margin: 0 auto; height: 32px;">
              <div
                class="mb-3"
                style="position: absolute; left:0; right:0; margin: auto;"
              >{{$t('no_service_objects_were_found')}}</div>
            </div>
          </template>

          <template v-slot:cell(serviceObjectId)="data">
            <a v-on:click="objectClick(data.item.serviceObjectId)" class="row-link">{{data.item.serviceObjectId}}</a>
          </template>

          <template v-slot:cell(contractId)="data">
            <a
              v-on:click="contractClick(data.item.contractId)"
              class="row-link"
            >{{data.item.contractId}}</a>
          </template>

          <template v-slot:cell(installationDate)="data">{{getDateFormatted(data.value)}}</template>

          <template v-slot:cell(warrantyEndDate)="data">{{getDateFormatted(data.value)}}</template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination
              v-if="totalRows > 0"
              align="center"
              ref="bottomPagination"
              label-prev-page="first"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              style="margin-top: 10px !important"
            />
          </div>
          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label
                for="inputPassword"
                class="col-sm-7 col-form-label text-right"
              >{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage"
                  :change="rowsPerPageChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'ServiceObjects',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function() {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'service_objects',
      filter: this.getFilter(this, 'so-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'so-sortBy', 'serviceObjectId'),
      sortDesc: this.getSortDesc(this, 'so-sortDesc', false),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'so-currentPage', 1),
      perPage: this.getPerPage(this, 'so-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen())
    };
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  methods: {
    filterContract(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'so-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters, 'serviceObjects');

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'so-filter', jsonItems);

      var self = this;

      setTimeout(function() {
        self.$refs.table.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'so-currentPage', 1);
    },
    serviceContractsProvider(ctx) {
      var url = this.getServiceUr(
        'serviceobjects',
        ctx,
        this.filter,
        this.generateOdataOrderByConditionString(ctx.sortBy, ctx.sortDesc, 'serviceObjects')
      );

      this.setSortBy(this, 'so-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'so-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'so-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'so-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    objectClick: function(objectNr) {
      this.$router.push({
        name: 'service-object',
        params: {
          id: objectNr
        }
      });
    },
    contractClick: function(contractNr) {
      this.$router.push({
        name: 'service-contract',
        params: {
          id: contractNr
        }
      });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'so-perPage', this.perPage);
    },
    getDateFormatted: function(date) {
      return (date === null || date === '') ? '' : this.$moment(date).format('DD/MM/YYYY');
    }
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  var tableHeight = window.innerHeight - 400;

  var maxRows = tableHeight / 40;

  if (maxRows < 3) {
    return 5;
  }

  return Math.floor(maxRows);
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'so-filter');

  const filterDefinition = [
    { id: 'serviceObjectId', value: '', type: 'input' },
    { id: 'customerInventoryId', value: '', type: 'input' },
    { id: 'objectType', value: '', type: 'input' },
    { id: 'serialNo', value: '', type: 'input' },
    { id: 'site', value: '', type: 'input' },
    { id: 'location', value: '', type: 'input' },
    { id: 'installationDate', value: '', type: 'dateRange' },
    { id: 'itemId', value: '', type: 'input' },
    { id: 'warrantyEndDate', value: '', type: 'dateRange' }
  ];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        if (filter.type === 'dateRange') {
          filter.value = { start: '', end: '' };

          filter.value.start = new Date(item.value.start);
          filter.value.end = new Date(item.value.end);
        } else {
          filter.value = item.value;
        }
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'serviceObjectId',
      label: context.$t('object'),
      sortable: true,
      thClass: 'tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr',
      thStyle: {
        maxWidth: '130px',
        minWidth: '130px'
      },
      tdStyle: {
        maxWidth: '130px',
        minWidth: '130px'
      },
      stickyColumn: true
    },
    {
      key: 'serialNo',
      label: context.$t('serialNo'),
      sortable: true,
      thClass: 'tr-left custom-th',
      tdClass: 'tr-left custom-tr',
      thStyle: {
        maxWidth: '200px',
        minWidth: '200px'
      },
      tdStyle: {
        maxWidth: '200px',
        minWidth: '200px'
      },
      stickyColumn: true
    },
    {
      key: 'objectType',
      label: context.$t('description'),
      sortable: true,
      tdClass: 'tr-left custom-tr',
      thClass: 'tr-left custom-th',
      thStyle: {
        maxWidth: '200px',
        minWidth: '200px'
      },
      tdStyle: {
        maxWidth: '200px',
        minWidth: '200px'
      },
      stickyColumn: true
    },
    {
      key: 'itemId',
      label: context.$t('itemId'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'customerInventoryId',
      label: context.$t('customerInventoryId'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'site',
      label: context.$t('site'),
      sortable: true,
      tdClass: 'tr-200 tr-left custom-tr',
      thClass: 'th-200 tr-left custom-th'
    },
    {
      key: 'location',
      label: context.$t('location'),
      sortable: true,
      tdClass: 'tr-150 tr-left custom-tr',
      thClass: 'th-150 tr-left custom-th'
    },
    {
      key: 'installationDate',
      label: context.$t('installationDate'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'contractId',
      label: context.$t('contract'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'coverageType',
      label: context.$t('coverage_type'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'installationNo',
      label: context.$t('installation_number'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'warrantyEndDate',
      label: context.$t('warrantyEndDate'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    }
  ];
}
</script>

<style>
.rn-test {
  width: 200px !important;
  max-width: 200px !important;
}
</style>

<style scoped>
.col-form-label-sm {
  color: red !important;
}
</style>
